var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 90,
    viewBox: "0 0 216 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 82H137C137.515 82 138.017 81.9444 138.5 81.8389C138.983 81.9444 139.485 82 140 82H192C195.866 82 199 78.866 199 75C199 71.134 195.866 68 192 68H186C182.134 68 179 64.866 179 61C179 57.134 182.134 54 186 54H205C208.866 54 212 50.866 212 47C212 43.134 208.866 40 205 40H183C186.866 40 190 36.866 190 33C190 29.134 186.866 26 183 26H119C122.866 26 126 22.866 126 19C126 15.134 122.866 12 119 12H62C58.134 12 55 15.134 55 19C55 22.866 58.134 26 62 26H22C18.134 26 15 29.134 15 33C15 36.866 18.134 40 22 40H47C50.866 40 54 43.134 54 47C54 50.866 50.866 54 47 54H7C3.13401 54 0 57.134 0 61C0 64.866 3.13401 68 7 68H46C42.134 68 39 71.134 39 75C39 78.866 42.134 82 46 82ZM209 82C212.866 82 216 78.866 216 75C216 71.134 212.866 68 209 68C205.134 68 202 71.134 202 75C202 78.866 205.134 82 209 82Z",
    fill: "#F3F6FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.1186 60.3066C96.0404 60.8599 96 61.4252 96 62C96 68.6274 101.373 74 108 74C114.627 74 120 68.6274 120 62C120 61.4252 119.96 60.8599 119.881 60.3066H149V87C149 88.6569 147.657 90 146 90H70C68.3431 90 67 88.6569 67 87V60.3066H96.1186Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121 60C121 67.1797 115.18 73 108 73C100.82 73 95 67.1797 95 60C95 59.7674 95.0061 59.5362 95.0182 59.3066H67L76.5604 31.0389C76.9726 29.8202 78.1159 29 79.4023 29H136.598C137.884 29 139.027 29.8202 139.44 31.0389L149 59.3066H120.982C120.994 59.5362 121 59.7674 121 60Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.098 60.9545C119.098 66.5025 114.129 72 108 72C101.871 72 96.9024 66.5025 96.9024 60.9545C96.9024 60.7748 96.9077 59.5962 96.918 59.4188H76L84.1614 39.5755C84.5132 38.6338 85.4891 38 86.5873 38H129.413C130.511 38 131.487 38.6338 131.839 39.5755L140 59.4188H119.082C119.092 59.5962 119.098 60.7748 119.098 60.9545Z",
    fill: "#F3F6FA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.25 59.5123V86C68.25 86.9665 69.0335 87.75 70 87.75H146C146.966 87.75 147.75 86.9665 147.75 86V59.5123L138.255 31.4393C138.015 30.7285 137.348 30.25 136.598 30.25H79.4023C78.6519 30.25 77.985 30.7285 77.7446 31.4393L68.25 59.5123Z",
    stroke: "#043087",
    strokeWidth: 2.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M81 59C84.9366 59 89.1849 59 93.7449 59C95.6212 59 95.6212 60.3186 95.6212 61C95.6212 67.6274 101.117 73 107.897 73C114.677 73 120.173 67.6274 120.173 61C120.173 60.3186 120.173 59 122.05 59H147M73.5737 59H76H73.5737Z",
    stroke: "#043087",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M133.1 6.30273L122 18.7559M107.1 2V18.7559V2ZM81 6.30273L92.0996 18.7559L81 6.30273Z",
    stroke: "#3DA8FF",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlEmpty);
export default __webpack_public_path__ + "static/media/il-empty.8907767d573be6ac6188d2595a3feee8.svg";
export { ForwardRef as ReactComponent };